module.exports = __webpack_public_path__ + "img/lusazu_logo.668b5583.png";